import Vue from 'vue';
import * as types from '../MutationTypes';

var state = {
  rooms: {},
  inventory: {},
  schemaVersion: '2.0'
};

const getters = {
  rooms: state => state.rooms,
  inventory: state => state.inventory
};

const actions = {
  updateRooms ({ commit, state }, items) {
    commit(types.ROOMS_UPDATE, items);
  },
  updateInventory ({ commit, state }, items) {
    commit(types.ROOMS_INVENTORY_UPDATE, items);
  },
  clearCache ({ commit, state }) {
    commit(types.ROOMS_CLEAR);
    commit(types.ROOMS_INVENTORY_CLEAR);
  }
};

const mutations = {
  [types.ROOMS_UPDATE] (state, { items, teamId }) {
    if (state.rooms[teamId] === undefined) {
      Vue.set(state.rooms, teamId, []);
    }
    if (items.length) {
      Vue.set(state.rooms, teamId, items);
    }
  },
  [types.ROOMS_INVENTORY_UPDATE](state, { items, teamId }) {
    if (state.inventory[teamId] === undefined) {
      Vue.set(state.inventory, teamId, []);
    }
    if (items.length) {
      Vue.set(state.inventory, teamId, items);
    }
  },
  [types.ROOMS_CLEAR](state) {
    if (state.rooms.constructor === Array) {
      state.rooms = {};
    }
    for (var teamId of Object.keys(state.rooms)) {
      state.rooms[teamId] = [];
    }
  },
  [types.ROOMS_INVENTORY_CLEAR] (state) {
    if (state.inventory.constructor === Array) {
      state.inventory = {};
    }
    for (var teamId of Object.keys(state.inventory)) {
      state.inventory[teamId] = [];
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/RoomsCache.js